import React, { Component } from "react";
import { Form, Spinner, Image } from "react-bootstrap";
import FilterComponent from "../../../component/filterComponent";

class Search extends Component {
  debounce = null;

  onChange = e => {
    const {
      keyName,
      onChange,
      debounceTime = 1000,
      callAfterDebounce
    } = this.props;
    const { value } = e.target;
    onChange && onChange(e, { name: keyName, value });
    this.debounce && clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      callAfterDebounce && callAfterDebounce({ name: keyName, value });
    }, debounceTime);
  };

  filtersInFilterComponent = filterListInFilterComponent => {
    const { onSelectingFilter } = this.props;
    onSelectingFilter(filterListInFilterComponent);
  };

  render() {
    const { props, onChange } = this;

    const {
      loader = true,
      classes = "",
      isLoading = false,
      loaderSrc = "",
      value = "",
      isSearchingUsers,
      isSearchingBestPractice,
      isSearchingIssue,
      filterList,
      getFilterId,
      makeSelectedNull,
      isFromMisSection,
      activeReport,
      onSelectingFilterInSearchComponent
    } = props;
    return (
      <div className={`search-container-component ${classes}`}>
        <Form.Control
          {...props}
          type="text"
          className="search-field"
          onChange={onChange}
          style={{
            width: window.location.pathname == "/mis" ? "330px" : "",
            marginRight: window.location.pathname == "/mis" ? "5px" : ""
          }}
        />
        {<span className="search-container-icon" />}
        {loader &&
        (isSearchingBestPractice === true ||
          isSearchingUsers === true ||
          isSearchingIssue === true) ? (
          <div className="search-container-spinner">
            <FilterComponent
              filterList={filterList}
              getFilterId={getFilterId}
              makeSelectedNull={makeSelectedNull}
              isUserFilter={true}
              isFromMisSection={isFromMisSection}
              activeReport={activeReport}
              onSelectedFilter={this.filtersInFilterComponent}
            />
          </div>
        ) : (
          <div className="search-container-spinner">
            {isLoading ? (
              <Spinner animation="border" variant="secondary" />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export { Search };
